import { useEffect, useContext } from 'react';
import {} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    AppContext,
    SttButtonFab,
    SttTable,
    SttTopControls,
    SttPage,
} from '../../../sporttia/all';
import { useToggle, useTuples, useCrud } from '../../../lib/hooks';
import { getPath } from '../../Pages';
import { PERMISSIONS } from '../../../lib/permissions';

type Filters = {
    name: string;
};

type StudentsResponse = {
    rows: any[];
    count: number;
};

export default function Students(): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [students, _setStudents, _Get] = useCrud<StudentsResponse>();
    const [filters, setFilter] = useTuples<Filters>({
        name: '',
    });
    const [_trash, toggleTrash] = useToggle(() => {
        loadStudents();
    });

    useEffect(() => {
        cxt?.setHeader({ title: t('Students') });
    }, []);

    function loadStudents(_params = { rows: 20 }) {
        // Get(`/scs/${cxt.sc?.id}/students`, {...params, ...filters, trash}).then(setStudents);
    }

    function goCreateNew() {
        // TODO: Put proper path ID here (likey singular)
        navigate(getPath('students', { id: 'create' }));
    }

    return (
        <SttPage title={t('Students')}>
            <SttTopControls
                p={2}
                fields={
                    [
                        {
                            caption: t('Name'),
                            type: 'text',
                            name: 'name',
                            value: filters.name,
                            onEnterKey: () => loadStudents(),
                        },
                    ] as any
                }
                onToggleTrash={toggleTrash}
                onChange={setFilter}
                onFilter={() => loadStudents()}
            />
            <SttTable
                onFetch={() => loadStudents()}
                data={students}
                columns={[
                    {
                        title: t('Name'),
                        type: 'text',
                        field: 'name',
                    },
                ]}
            />
            <SttButtonFab
                onClick={goCreateNew}
                permission={PERMISSIONS.ACTIVITY.MODIFY}
            />
        </SttPage>
    );
}
